import { CLIENT_LOGOS } from "@/lib/content";

export default function ClientTicker() {
  if (!CLIENT_LOGOS.length) return null;
  return (
    <section className="border-b border-slate-100 bg-white py-10" data-testid="client-logo-ticker" aria-label="Our clients">
      <p className="eyebrow mb-8 text-center">Trusted by organisations worldwide</p>
      <div className="relative overflow-hidden">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-white to-transparent" aria-hidden="true" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-white to-transparent" aria-hidden="true" />
        <div className="marquee-track items-center">
          {[0, 1].map((half) => (
            <div key={half} className="flex shrink-0 items-center">
              {CLIENT_LOGOS.map((logo, i) => (
                <img
                  key={`${half}-${i}`}
                  src={logo.src}
                  alt={logo.name}
                  className="mx-10 h-10 sm:h-12 w-auto object-contain transition-transform duration-300 hover:scale-110"
                />
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
